module.exports = "https://trybtryb-legacy.web.app/img/circle_gray.c1afb9ef.svg";